import styled from "@emotion/styled";

import { useDimensions } from "../perspective/DimensionsContext";
import { Connector } from "./Connector";
import { defaultCurveConfig } from "./curve";
import { SvgCanvas } from "./styled/SvgCanvas";
import type { BoxedConnector, ConnectorEnd, ConnectorInteraction, CurveConfig } from "./types";
import { useCurvableConnectors } from "./useCurvableConnectors";

const SHOW_CONNECTOR_DEBUG = false;

const debugPaper = false;

const PaperCanvas = styled.canvas`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  pointer-events: all;
`;

type Props = {
  connectors: BoxedConnector[];
  options?: CurveConfig;
  movingSceneId?: number | string;
  onConnectorInteraction?: (interaction: ConnectorInteraction, id: string, end: ConnectorEnd) => void;
};

export const Connectors = ({
  connectors: boxedConnectors,
  options = defaultCurveConfig,
  movingSceneId,
  onConnectorInteraction,
}: Props) => {
  const { usableWidth, usableHeight, positionOrigin } = useDimensions();

  const connectors = useCurvableConnectors({ boxedConnectors, options, movingSceneId, debugPaper });

  return (
    <>
      {debugPaper && <PaperCanvas id="paper-canvas" />}
      <SvgCanvas
        width={usableWidth}
        height={usableHeight}
        positionOrigin={positionOrigin}
        data-test="connectors-container"
      >
        <g data-test="list">
          {connectors.map((c) => (
            <Connector
              key={`connector_${c.id}`}
              connector={c}
              debug={SHOW_CONNECTOR_DEBUG}
              options={{ ...options, showTouchables: !!c.showTouchables }}
              color={c.color}
              onInteraction={onConnectorInteraction}
              dataAttribute={c.dataAttribute}
            />
          ))}
        </g>
      </SvgCanvas>
    </>
  );
};
